import React, { useCallback, useEffect, useState } from "react";
import { styled } from "@linaria/react";
import { useAvivaSelector } from "@redux/hook";
import { css } from "@linaria/core";
import Icon from "@components/_Revamp/Icon";
import _, { isEmpty } from "lodash";
import { Helpers } from "@utils/helpers";
import { Text } from "../Text";
export interface SheetContainerProps {
  isVisible?: boolean;
}
export interface BottomSheetContainerProps {
  isDisplaying?: boolean;
}

const ProductOverviewMobile = () => {
  // const policyName = useAvivaSelector(
  //   (state) => state.shieldStarterStep2.policyName
  // );
  const addRemoveGrey = useCallback(({ flag, stepper, header }: any) => {
    if (!stepper) stepper = document.querySelector("#stepper-bg")!;
    if (!header) header = document.querySelector("#singlife-header")!;
    if (!stepper || !header) return;
    if (flag) {
      stepper.classList.add("gray_fill2");
      header.classList.add("gray_fill2");
    } else {
      stepper.classList.remove("gray_fill2");
      header.classList.remove("gray_fill2");
      setIsContentDisplay(false);
    }
  }, []);
  const planData = useAvivaSelector((state) => state.everGreenStep1.quotation);
  const staticdata = useAvivaSelector(
    (state) => state.everGreenStep1.staticData
  );
  const rawQuotaion = useAvivaSelector(
    (state) => state.shieldStarterStep2.rawQuotaion
  );

  const isQuoteConfirm = !isEmpty(rawQuotaion) || true;
  const [tempPlanOverview, setTempPlanOverview] = useState<any>([]);
  const [tempPremiumBreackdown, setTempPremiumBreackdown] = useState<any>([]);
  const [isContentDisplay, setIsContentDisplay] = useState<boolean>(false);

  useEffect(() => {
    if (planData.sqsquotation.maturityPayout > -1) {
      const Overview = [
        {
          text: "Plan Selected",
          value: staticdata.productName,
        },
        {
          text: "Selected Amount",
          value: Helpers.toCurrency(Number(planData.investingAmount) || 0),
        },
      ];

      setTempPlanOverview(Overview);
      const Premium = [
        {
          text: "Cash Surrender Value",
          value: Helpers.toCurrency(
            Number(planData.sqsquotation.surrenderValue) || 0
          ),
        },
        {
          text: "Death Benefit",
          value: Helpers.toCurrency(
            Number(planData.sqsquotation.deathBenefit) || 0
          ),
        },
        {
          text: "Maturity Benefit",
          value: `${Helpers.toCurrency(
            Number(planData.sqsquotation.maturityPayout) || 0
          )}`,
        },
      ];

      setTempPremiumBreackdown(Premium);
    }
  }, [planData.sqsquotation]);

  useEffect(() => {
    const stepper = document.querySelector("#stepper-bg")!;
    const header = document.querySelector("#singlife-header")!;
    if (isContentDisplay) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
      addRemoveGrey({ flag: true, header, stepper });
      stepper && stepper.addEventListener("touchend", addRemoveGrey);
      header && header.addEventListener("touchend", addRemoveGrey);
    } else {
      document.body.style.overflow = "unset";
      document.body.style.touchAction = "unset";
      addRemoveGrey({ flag: false, header, stepper });
      stepper && stepper.removeEventListener("touchend", addRemoveGrey);
      header && header.removeEventListener("touchend", addRemoveGrey);
    }
  }, [isContentDisplay]);

  const toggleDisplay = () => {
    setIsContentDisplay(!isContentDisplay);
  };

  return (
    <div>
      <OverlayDiv
        onClick={() => {
          setIsContentDisplay(false);
        }}
        className={isContentDisplay ? `${OverlayDivVisible}` : ``}
      ></OverlayDiv>
      <ContainerWrapper id="product-overview-mob" isVisible={isQuoteConfirm}>
        <UpperContainer isDisplaying={isContentDisplay}>
          <UperWrap firstSpan>
            <span style={{ color: "#FFF", alignItems: "center" }}>
              <span>Quote:</span>{" "}
              <span style={{ fontSize: "18px" }}>
                {Helpers.toCurrency(Number(planData?.investingAmount) || 0)}
              </span>
            </span>
            <span onClick={toggleDisplay}>
              <AccountBalanceValue>
                {isContentDisplay ? "Collapse" : "Expand"}
              </AccountBalanceValue>
              <Icon
                className={
                  isContentDisplay
                    ? `${IconRotate} ${IconPosition}`
                    : IconPosition
                }
                name={"evergreen-drawer-arrow"}
              />
            </span>
          </UperWrap>
          <UperWrap className={addscroll}>
            <Tag>{staticdata.productName}</Tag>
          </UperWrap>
        </UpperContainer>
        <BottomContentContainerWrapper isDisplaying={isContentDisplay}>
          <ListingContainer margin={"0"}>
            <Text variant="title" margin="0px 0px 8px 0px" color="#ffffff">
              Plan Overview
            </Text>
            {tempPlanOverview?.map((entries: any) => {
              return (
                <DataList>
                  <span>{entries.text}</span>
                  <span>{entries.value}</span>
                </DataList>
              );
            })}
            <Text variant="title" margin="24px 0px 8px 0px" color="#ffffff">
              Benefits and Returns Breakdown
            </Text>
            {tempPremiumBreackdown?.map((entries: any) => {
              return entries.text ? (
                <DataList>
                  <span dangerouslySetInnerHTML={{ __html: entries.text }} />
                  <span>{entries.value}</span>
                </DataList>
              ) : null;
            })}
            <hr
              style={{ borderBottom: "1px solid #C4C4C4", margin: "24px 0" }}
            />
            <DataList>
              <span style={{ fontSize: "12px" }}>
                <b
                  style={{
                    color: "#B0ECE6",
                    fontSize: "18px",
                    fontWeight: 600,
                  }}
                >
                  Single Premium
                </b>
              </span>
              <span
                style={{ color: "#B0ECE6", fontSize: "18px", fontWeight: 600 }}
              >
                {Helpers.toCurrency(Number(planData.investingAmount) || 0)}
              </span>
            </DataList>
          </ListingContainer>
        </BottomContentContainerWrapper>
      </ContainerWrapper>
    </div>
  );
};

export default ProductOverviewMobile;

const ContainerWrapper = styled.div<SheetContainerProps>`
  display: none;
  z-index: 101;
  position: fixed;
  background-color: #434343;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 16px 16px 0 0;
  @media screen and (max-width: 767px) {
    display: ${(props) => (props.isVisible ? "block" : "none")};
  }
`;

const UpperContainer = styled.div<BottomSheetContainerProps>`
  justify-content: center;
  height: auto;
  padding-top: 16px;
  padding-bottom: ${(props) => (props.isDisplaying ? "24px" : "48px")};
`;

const AccountBalanceValue = styled.p`
  color: #b0ece6;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.48px;
`;

const IconPosition = css`
  color: #883e89;
  width: 20px;
  height: 20px;
  object-fit: scale-down;

  @media screen and (min-width: 768px) {
    right: 0;
  }
  transform: translateY(-10%);
`;

const IconRotate = css`
  transform: translateY(-10%) rotate(180deg);
`;

const BottomContentContainerWrapper = styled.div<BottomSheetContainerProps>`
  z-index: 50;
  padding: ${(props) => (props.isDisplaying ? "24px" : "0px")};
  display: block;
  overflow: hidden;
  max-height: ${(props) => (props.isDisplaying ? "300px" : "0px")};
  transition: max-height 0.3s linear;
  padding-top: ${(props) => (props.isDisplaying ? "24px" : "0px")};
  padding-bottom: ${(props) => (props.isDisplaying ? "48px" : "0px")};
  margin-bottom: ${(props) => (props.isDisplaying ? "0px" : "-5px")};

  border-top: 1px solid #c4c4c4;
`;

const OverlayDiv = styled.div`
  z-index: 100;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(1, 1, 1, 0.5);
  /* transition: visibility 0.3s, opacity 0.3s linear; */
`;

const OverlayDivVisible = css`
  opacity: 1;
  visibility: visible;
  @media screen and (min-width: 768px) {
    opacity: 0;
    visibility: hidden;
  }
`;
const summary = { text: "Total Annual Premium", value: "-" };

export interface FormContainerProps {
  margin?: string;
}

const ListingContainer = styled.div<FormContainerProps>``;

const DataList = styled.div`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
  line-height: 19.6px;
  span {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    white-space: pre;
    letter-spacing: 0.48px;
  }
  & span:nth-child(1) {
    flex-wrap: wrap;
    width: 60%;
  }
  & span:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    font-weight: 600;
  }
`;

const UperWrap = styled.div<{ firstSpan?: boolean }>`
  display: flex;
  gap: 8px;
  justify-content: ${(props) => (props.firstSpan ? "space-between" : "")};
  margin-bottom: ${(props) => (props.firstSpan ? "10px" : "0px")};
  padding: 0 24px;
  span {
    font-size: 12px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.48px;
    display: flex;
    gap: 10px;
  }
`;

const Tag = styled.span`
  padding: 4px 8px;
  border-radius: 8px;
  background: #f5f5f5;
  color: #434343;
  white-space: nowrap;
`;

const addscroll = css`
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
`;
